import React from 'react';
import { CheckCircle, AlertCircle, Clock } from 'lucide-react';

const resultConfig = {
  Success: {
    label: 'Success',
    textColor: 'text-status-success',
    bgColor: 'bg-status-success-bg',
    borderColor: 'border-status-success-border',
    icon: CheckCircle,
  },
  Failed: {
    label: 'Failed',
    textColor: 'text-status-error',
    bgColor: 'bg-status-error-bg',
    borderColor: 'border-status-error-border',
    icon: AlertCircle,
  },
};

const fallbackConfig = {
  label: 'Unknown',
  textColor: 'text-status-pending',
  bgColor: 'bg-status-pending-bg',
  borderColor: 'border-transparent',
  icon: Clock,
};

export default function StatusBadge({ result }) {
  const config = resultConfig[result] || fallbackConfig;
  const Icon = config.icon;

  return (
    <span
      className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold border ${config.textColor} ${config.bgColor} ${config.borderColor}`}
    >
      <Icon size={12} />
      {config.label}
    </span>
  );
}
